// @flow
/*eslint no-console:0*/
export default function log(...args: any) {
  if (process.env.DRAGGABLE_DEBUG) console.log(...args);
}



// WEBPACK FOOTER //
// global/lib/react-draggable/lib/utils/log.js